import {JS_DATA_REPORT} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/dataReport/jsDataMonitor/dataReport/index.vue'),
    path: 'dataReport',
    name: JS_DATA_REPORT,
    meta: {
        title: 'JS数据报表',
        name: JS_DATA_REPORT
    }
};